import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { AlertTriangle } from 'lucide-react'
import { formatDateTime, formatEndDateTime } from '@/lib/utils/timeFormat'

interface DeleteScanDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  scan: { id: string; timeFrame?: { from?: Date | undefined; to?: Date | undefined } } | null
  onConfirm: () => void
  isDeleting: boolean
}

export function DeleteScanDialog({
  open,
  onOpenChange,
  scan,
  onConfirm,
  isDeleting,
}: DeleteScanDialogProps) {
  if (!scan) return null

  const scanTitle =
    scan.timeFrame?.from && scan.timeFrame?.to
      ? `${formatDateTime(scan.timeFrame.from)} - ${formatEndDateTime(scan.timeFrame.from, scan.timeFrame.to)}`
      : 'Naamloze scan'

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <div className="flex items-center gap-3">
            <div className="flex items-center justify-center h-10 w-10 rounded-full bg-red-100 dark:bg-red-950">
              <AlertTriangle className="h-5 w-5 text-red-600 dark:text-red-400" />
            </div>
            <DialogTitle>Scan verwijderen</DialogTitle>
          </div>
          <DialogDescription className="pt-2">
            Weet je zeker dat je de scan <strong>"{scanTitle}"</strong> wilt verwijderen?
            <br />
            <br />
            De analyse wordt gemarkeerd als verwijderd maar blijft beschikbaar in het archief. Je
            kunt verwijderde analyses bekijken door de status filter in te stellen op 'Verwijderd'.
          </DialogDescription>
        </DialogHeader>

        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={isDeleting}>
            Annuleren
          </Button>
          <Button variant="destructive" onClick={onConfirm} disabled={isDeleting}>
            {isDeleting ? 'Verwijderen...' : 'Verwijderen'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
